﻿package org.example.project.screens_cus_mobile

import org.jetbrains.compose.web.css.*

internal object MitarbeiterMeinUrlaubTabletStyles : StyleSheet() {
    val shell by style {
        width(100.percent)
        minHeight(0.px)
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        gap(12.px)
    }

    val shellWithDay by style {}

    val content by style {
        position(Position.Relative)
        minWidth(0.px)
        minHeight(0.px)
        display(DisplayStyle.Grid)
        property("grid-template-columns", "minmax(0, 1fr)")
        gap(14.px)
        overflow("hidden")
    }

    val monthPane by style {
        minWidth(0.px)
        display(DisplayStyle.Flex)
        justifyContent(JustifyContent.Center)
        alignItems(AlignItems.Start)
        padding(8.px)
        property("transition", "transform 220ms ease, width 220ms ease")
        property("transform", "translateX(0)")
    }

    val monthPaneShifted by style {
        property("transform", "translateX(-10px)")
    }

    val dayPane by style {
        position(Position.Absolute)
        top(86.px)
        left(58.percent)
        width(38.percent)
        maxHeight(78.percent)
        overflowY("auto")
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        gap(10.px)
        padding(12.px)
        color(Color.white)
        property("background", "rgba(17,20,25,0.96)")
        border(1.px, LineStyle.Solid, rgba(255, 255, 255, 0.16))
        borderRadius(8.px)
        property("box-shadow", "0 18px 46px rgba(0,0,0,0.34)")
        boxSizing("border-box")
    }

    val weekPane by style {
        minWidth(0.px)
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        gap(12.px)
        padding(4.px, 0.px)
    }

    val dayPaneFull by style {
        minWidth(0.px)
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        gap(12.px)
    }

    val modeRail by style {
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Row)
        justifyContent(JustifyContent.Center)
        alignItems(AlignItems.Center)
        alignSelf(AlignSelf.FlexEnd)
        gap(8.px)
        padding(0.px)
    }

    val dayHeader by style {
        minHeight(42.px)
        display(DisplayStyle.Flex)
        alignItems(AlignItems.Center)
        justifyContent(JustifyContent.SpaceBetween)
        gap(10.px)
        padding(0.px, 2.px)
        color(Color.white)
    }

    val dayTitle by style {
        minWidth(0.px)
        fontSize(18.px)
        fontWeight("900")
        property("word-break", "break-word")
    }

    val dayCount by style {
        color(rgba(255, 255, 255, 0.62))
        fontSize(12.px)
        fontWeight("900")
    }

    val timeShell by style {
        display(DisplayStyle.Grid)
        property("grid-template-columns", "250px minmax(0, 1fr)")
        gap(14.px)
        alignItems(AlignItems.Start)
        minHeight(0.px)
    }

    val timeMonthRail by style {
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        gap(10.px)
        minWidth(0.px)
    }

    val timeAccount by style {
        padding(12.px)
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        gap(10.px)
        border(1.px, LineStyle.Solid, rgba(255, 255, 255, 0.12))
        borderRadius(8.px)
        backgroundColor(rgba(255, 255, 255, 0.045))
        boxSizing("border-box")
    }

    val timeMonthSummary by style {
        padding(10.px)
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        gap(5.px)
        color(Color.white)
        border(1.px, LineStyle.Solid, rgba(255, 255, 255, 0.10))
        borderRadius(8.px)
        backgroundColor(rgba(255, 255, 255, 0.035))
    }

    val timeMonthName by style {
        fontSize(13.px)
        fontWeight("900")
    }

    val timeSummaryLine by style {
        display(DisplayStyle.Flex)
        justifyContent(JustifyContent.SpaceBetween)
        gap(8.px)
        color(rgba(255, 255, 255, 0.70))
        fontSize(11.px)
        fontWeight("800")
    }

    val timeYearPane by style {
        minWidth(0.px)
        maxHeight(74.vh)
        overflow("auto")
    }

    val timeYearGrid by style {
        display(DisplayStyle.Grid)
        property("grid-template-columns", "minmax(190px, 220px) repeat(31, minmax(42px, 1fr))")
        property("grid-auto-rows", "72px")
        gap(0.px)
        minWidth((190 + 31 * 42).px)
    }

    val timeYearHeaderCell by style {
        position(Position.Sticky)
        top(0.px)
        property("z-index", "3")
        minHeight(42.px)
        display(DisplayStyle.Flex)
        alignItems(AlignItems.Center)
        justifyContent(JustifyContent.Center)
        color(rgba(255, 255, 255, 0.54))
        fontSize(13.px)
        fontWeight("900")
        backgroundColor(Color("#20242a"))
        property("border-right", "1px solid rgba(255,255,255,0.08)")
        property("border-bottom", "1px solid rgba(255,255,255,0.14)")
    }

    val timeYearIdentityHeader by style {
        left(0.px)
        property("z-index", "4")
        justifyContent(JustifyContent.FlexStart)
        padding(0.px, 12.px)
        boxSizing("border-box")
    }

    val timeYearMonthCell by style {
        position(Position.Sticky)
        left(0.px)
        property("z-index", "2")
        minHeight(72.px)
        padding(0.px, 10.px)
        display(DisplayStyle.Flex)
        alignItems(AlignItems.Center)
        gap(9.px)
        color(Color.white)
        backgroundColor(Color("#191d22"))
        property("border-right", "1px solid rgba(255,255,255,0.18)")
        property("border-bottom", "2px solid rgba(255,255,255,0.48)")
        property("background-clip", "padding-box")
        boxSizing("border-box")
    }

    val timeYearMonthContent by style {
        width(100.percent)
        display(DisplayStyle.Flex)
        alignItems(AlignItems.Center)
        justifyContent(JustifyContent.SpaceBetween)
        gap(10.px)
        minWidth(0.px)
    }

    val timeYearMonthName by style {
        property("flex", "1 1 auto")
        overflow("hidden")
        property("text-overflow", "ellipsis")
        property("white-space", "nowrap")
        fontSize(15.px)
        fontWeight("900")
    }

    val timeYearMonthBalance by style {
        color(rgba(255, 255, 255, 0.54))
        fontSize(13.px)
        fontWeight("800")
        property("white-space", "nowrap")
    }

    val timeYearEmptyCell by style {
        minHeight(72.px)
        backgroundColor(rgba(255, 255, 255, 0.018))
        property("border-right", "1px solid rgba(255,255,255,0.18)")
        property("border-bottom", "2px solid rgba(255,255,255,0.48)")
        property("background-clip", "padding-box")
        boxSizing("border-box")
    }

    val timeYearDayCell by style {
        position(Position.Relative)
        minHeight(72.px)
        padding(4.px)
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        alignItems(AlignItems.Center)
        justifyContent(JustifyContent.Center)
        gap(3.px)
        color(Color.white)
        property("border-right", "1px solid rgba(255,255,255,0.18)")
        property("border-bottom", "2px solid rgba(255,255,255,0.48)")
        property("background-clip", "padding-box")
        backgroundColor(rgba(255, 255, 255, 0.04))
        boxSizing("border-box")
    }

    val timeYearDaySelected by style {
        property("border-color", "rgba(255,47,70,0.64)")
        backgroundColor(rgba(255, 47, 70, 0.20))
    }

    val timeYearWeekday by style {
        color(rgba(255, 255, 255, 0.68))
        fontSize(11.px)
        fontWeight("900")
        lineHeight("1")
    }

    val timeYearDayNumber by style {
        fontSize(15.px)
        fontWeight("900")
        lineHeight("1")
    }

    val timeYearSummaryCell by style {
        position(Position.Sticky)
        left(0.px)
        property("z-index", "2")
        minHeight(72.px)
        padding(0.px, 10.px)
        display(DisplayStyle.Flex)
        alignItems(AlignItems.Center)
        justifyContent(JustifyContent.Center)
        backgroundColor(Color("#20242a"))
        property("border-right", "1px solid rgba(255,255,255,0.18)")
        property("border-bottom", "2px solid rgba(255,255,255,0.48)")
        boxSizing("border-box")
    }

    val timeYearSummaryContent by style {
        width(100.percent)
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        alignItems(AlignItems.Center)
        textAlign("center")
        gap(5.px)
    }

    val timeYearSummaryLabel by style {
        color(rgba(255, 255, 255, 0.62))
        fontSize(12.px)
        fontWeight("800")
    }

    val timeYearSummaryValue by style {
        color(Color.white)
        fontSize(13.px)
        fontWeight("900")
        property("white-space", "nowrap")
    }

    val timeYearLegendCell by style {
        property("grid-column", "2 / -1")
        minWidth(0.px)
        minHeight(72.px)
        display(DisplayStyle.Flex)
        alignItems(AlignItems.Center)
        justifyContent(JustifyContent.Center)
        color(rgba(255, 255, 255, 0.62))
        fontSize(13.px)
        fontWeight("900")
        property("border-bottom", "2px solid rgba(255,255,255,0.48)")
    }

    val timePositiveBalance by style {
        color(Color("#84e1a7"))
    }

    val timeNegativeBalance by style {
        color(Color("#ff6b6b"))
    }

    val timeDayWarning by style {
        position(Position.Absolute)
        right(4.px)
        top(4.px)
        width(14.px)
        height(14.px)
        borderRadius(50.percent)
        display(DisplayStyle.Flex)
        alignItems(AlignItems.Center)
        justifyContent(JustifyContent.Center)
        color(Color.white)
        backgroundColor(rgba(0, 0, 0, 0.34))
        fontSize(9.px)
        fontWeight("900")
        lineHeight("1")
    }

    val requestPanel by style {
        width(100.percent)
        maxWidth(1180.px)
        alignSelf(AlignSelf.Center)
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
    }

    val fullPage by style {
        maxWidth(1180.px)
    }

    val mainHeader by style {
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        alignItems(AlignItems.Center)
        gap(12.px)
        paddingBottom(8.px)
    }

    val mainTitle by style {
        margin(0.px)
        color(Color.white)
        fontSize(24.px)
        fontWeight("900")
        textAlign("center")
    }

    val mainButtonBar by style {
        display(DisplayStyle.Flex)
        flexWrap(FlexWrap.Wrap)
        justifyContent(JustifyContent.Center)
        gap(8.px)
        media(mediaMaxWidth(760.px)) {
            self style {
                display(DisplayStyle.None)
            }
        }
    }

    val requestForm by style {
        width(100.percent)
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        gap(14.px)
        color(Color.white)
        boxSizing("border-box")
    }

    val requestHeader by style {
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        gap(10.px)
        alignItems(AlignItems.Center)
    }

    val requestTypeSelector by style {
        width(100.percent)
        display(DisplayStyle.Flex)
        flexWrap(FlexWrap.Wrap)
        justifyContent(JustifyContent.FlexStart)
        gap(8.px)
    }

    val requestWorkspace by style {
        display(DisplayStyle.Grid)
        property("grid-template-columns", "minmax(520px, 1fr) minmax(280px, 340px)")
        gap(14.px)
        alignItems(AlignItems.Stretch)
        justifyContent(JustifyContent.Center)
        media(mediaMaxWidth(760.px)) {
            self style {
                display(DisplayStyle.Flex)
                flexDirection(FlexDirection.Column)
            }
        }
    }

    val requestCard by style {
        minWidth(0.px)
        minHeight(0.px)
        padding(12.px)
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        gap(12.px)
        border(1.px, LineStyle.Solid, rgba(255, 255, 255, 0.12))
        borderRadius(8.px)
        backgroundColor(rgba(255, 255, 255, 0.04))
        boxSizing("border-box")
    }

    val requestMetricsRow by style {
        display(DisplayStyle.Grid)
        property("grid-template-columns", "minmax(520px, 1fr) minmax(280px, 340px)")
        gap(12.px)
        justifyContent(JustifyContent.Center)
        flexShrink(0)
        media(mediaMaxWidth(760.px)) {
            self style {
                property("grid-template-columns", "1fr")
            }
        }
    }

    val requestReasonGroup by style {
        alignSelf(AlignSelf.Stretch)
    }

    val requestCardTitle by style {
        color(rgba(255, 255, 255, 0.62))
        fontSize(11.px)
        fontWeight("900")
        property("text-transform", "uppercase")
    }

    val requestCalendarGrid by style {
        display(DisplayStyle.Grid)
        property("grid-template-columns", "repeat(7, minmax(0, 1fr))")
        gap(5.px)
    }

    val requestEventSummary by style {
        minHeight(42.px)
        padding(10.px, 12.px)
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        gap(0.px)
        color(Color.white)
        backgroundColor(rgba(255, 255, 255, 0.06))
        border(1.px, LineStyle.Solid, rgba(255, 255, 255, 0.12))
        borderRadius(8.px)
        boxSizing("border-box")
        overflow("hidden")
    }

    val requestEventRow by style {
        minHeight(38.px)
        display(DisplayStyle.Grid)
        property("grid-template-columns", "minmax(0, 1fr) minmax(0, 1fr)")
        alignItems(AlignItems.Center)
        gap(10.px)
        property("border-bottom", "1px solid rgba(255,255,255,0.08)")
    }

    val requestEventLabel by style {
        color(rgba(255, 255, 255, 0.62))
        fontSize(12.px)
        fontWeight("800")
    }

    val requestEventValue by style {
        color(Color.white)
        fontSize(13.px)
        fontWeight("900")
        textAlign("right")
        property("word-break", "break-word")
    }

    val requestActions by style {
        display(DisplayStyle.Flex)
        justifyContent(JustifyContent.Center)
        alignItems(AlignItems.Center)
        gap(12.px)
        paddingTop(8.px)
    }
}

